/**
 * User Permissions API Service
 * Handles communication with the backend /auth/user-permissions/ endpoint
 */

import { apiURL } from '../API/constants';

class UserPermissionsAPI {
  constructor(baseURL = apiURL) {
    this.baseURL = baseURL;
  }

  /**
   * Fetch user permissions from the backend API
   * @param {string} accessToken - JWT access token
   * @returns {Promise<Object>} - User permissions and roles
   */
  async getUserPermissions(accessToken) {
    try {
      const response = await fetch(`${this.baseURL}/auth/user-permissions/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user permissions:', error);
      throw error;
    }
  }

  /**
   * Check if the API endpoint is available
   * @param {string} accessToken - JWT access token
   * @returns {Promise<boolean>} - True if API is available
   */
  async isAPIAvailable(accessToken) {
    try {
      const response = await fetch(`${this.baseURL}/auth/user-permissions/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      const contentType = response.headers.get('content-type');
      return response.ok && contentType && contentType.includes('application/json');
    } catch (error) {
      return false;
    }
  }
}

export default UserPermissionsAPI;
